import Settings16 from '@carbon/icons-react/es/settings/16';
import { faCalendarStar } from '@fortawesome/pro-duotone-svg-icons';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import {
  CardEmptyState as CardEmptyStateAtom,
  EmptyStateIcon,
} from 'components/atoms/empty-state';
import { RoutePaths } from 'constant';

const CardEmptyState = styled(CardEmptyStateAtom)`
  justify-content: center !important;
  margin: var(--spacing-05);
`;

const RedirectWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-02);
`;

export const EmptyMessage = () => {
  return (
    <CardEmptyState
      image={<EmptyStateIcon icon={faCalendarStar} />}
      title={<FormattedMessage id="key_events" />}
      message={<FormattedMessage id="settings.events.empty_state" />}
      secondaryCTA={
        <RedirectWrapper>
          <Settings16 />
          <FormattedMessage
            id="settings.events.manage_events"
            values={{
              a: (chunks) => (
                <Link to={RoutePaths.keyeventsAndIntervals}>{chunks}</Link>
              ),
            }}
          />
        </RedirectWrapper>
      }
    />
  );
};
